module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_inside_04.ef2ff805.jpg";